import { useEffect, useRef } from '@wordpress/element';
import QRCode from 'qrcode';

function QrCode({ tokenUrl }) {
	const canvasRef = useRef(null);

	useEffect(() => {
		if (!tokenUrl || !canvasRef.current) return;

		const options = {
			color: {
				dark: '#000000',
				light: '#ffffff',
			},
			width: 150,
			margin: 1,
			errorCorrectionLevel: 'L',
		};

		QRCode.toCanvas(canvasRef.current, tokenUrl, options, (error) => {
			if (error) {
				console.error('QR code generation error:', error);
			} else {
			}
		});
	}, [tokenUrl]);

	return (
		<>
			<canvas
				ref={canvasRef}
				data-url={tokenUrl}
				id="qr-code-canvas"
				style={{ display: 'block', margin: 'auto' }}
			></canvas>
		</>
	);
}

export default QrCode;
